ANALYTICS_ENABLED = document.querySelector("meta[name=analytics_enabled]")?.content is "true"

# Report clicks on the "Contact Us" link
reportContactClick = ->
  Analytics.trackEvent("Clicked Support Link", {location: "footer link"})

if contactLink = document.querySelector('.analytics-contact-click')
  contactLink.addEventListener('click', reportContactClick, true)

# Report pageviews in the marketing site as marketing page views
analytics.page("Marketing") if window.analytics && ANALYTICS_ENABLED
